@if (legendInfo) {
  <div #container class="legend-layer">
    @if (showTitle) {
      <strong [class.out-of-scale]="!legendInfo.isInScale">{{legendInfo.layer.title}}</strong>
    }
    <tm-legend-image [legend]="getLegend(legendInfo)" [width]="width()" />
  </div>
}
